import Papa from "papaparse";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { serializeValue } from "../utils/firestoreValueUtils";

export function exportJson(rows, filename) {
  const blob = new Blob([JSON.stringify(rows, null, 2)], { type: "application/json" });
  saveAs(blob, filename || "export.json");
}

export function exportCsv(rows, filename) {
  const flat = rows.map((r) => ({ id: r.id, ...serializeValue(r.data) }));
  const csv = Papa.unparse(flat);
  const blob = new Blob([csv], { type: "text/csv" });
  saveAs(blob, filename || "export.csv");
}

export function exportExcel(rows, filename) {
  const flat = rows.map((r) => ({ id: r.id, ...serializeValue(r.data) }));
  const ws = XLSX.utils.json_to_sheet(flat);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFile(wb, filename || "export.xlsx");
}

export function parseImportFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const name = file.name.toLowerCase();
        if (name.endsWith(".json")) {
          const rows = JSON.parse(e.target.result);
          resolve(Array.isArray(rows) ? rows : [rows]);
        } else if (name.endsWith(".csv")) {
          const parsed = Papa.parse(e.target.result, { header: true });
          resolve(parsed.data.filter((r) => Object.keys(r).length));
        } else if (name.endsWith(".xlsx") || name.endsWith(".xls")) {
          const wb = XLSX.read(e.target.result, { type: "array" });
          const sheet = wb.Sheets[wb.SheetNames[0]];
          resolve(XLSX.utils.sheet_to_json(sheet));
        } else {
          reject(new Error("Unsupported file type"));
        }
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = reject;
    if (file.name.match(/\.xlsx?$/i)) reader.readAsArrayBuffer(file);
    else reader.readAsText(file);
  });
}

export function detectDuplicates(rows, existingIds) {
  const dupes = [];
  const seen = new Set();
  rows.forEach((r, i) => {
    const id = r.id || r.docId;
    if (id && existingIds.has(id)) dupes.push({ index: i, id, reason: "exists_in_firestore" });
    if (id && seen.has(id)) dupes.push({ index: i, id, reason: "duplicate_in_file" });
    if (id) seen.add(id);
  });
  return dupes;
}
